define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare, Controller) {

	return declare(Controller, {
		/**
		 * @override
		 * Redraw view - if query has changed then store should force new request
		 */
		postProcessSuccess() {
			this.setProgress();

			// scroll position should be placed at top after filtering - no reason to restore original scroll position
			this.widget._scrollPosition = 0;

			return this.widget.redrawData();
		}
	});
});